import { ChevronLeft, ChevronRight } from "lucide-react";
import Pagination from "../../../Common/Pagination/CommonPagination";
import { Button } from "Components/ui/button";

const ROWS_PER_PAGE_OPTIONS = [25, 50, 100];

/**
 * Page-level pagination footer for the Pending Products screen.
 *
 * Two display modes depending on what the backend returns:
 *  - Numbered `<Pagination>` when `knownTotalPages > 1`.
 *  - Prev/Next buttons when only `hasMore` is known (current behaviour of
 *    POST /admin/temp-products/list — total isn't returned).
 */
const PendingProductsFooter = ({
  page,
  perPage,
  knownTotal,
  knownTotalPages,
  hasMore,
  productsOnPage,
  onPageChange,
  onPerPageChange,
}) => {
  const numberedPagination = knownTotalPages != null && knownTotalPages > 1;
  const showPrevNext = !numberedPagination && (hasMore || page > 1);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-1">
      <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
        <label className="flex items-center gap-2">
          <span>Rows per page</span>
          <select
            className="h-9 w-20 rounded-md border border-input bg-background px-2 text-sm shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1"
            value={perPage}
            onChange={(e) => onPerPageChange(Number(e.target.value))}
          >
            {ROWS_PER_PAGE_OPTIONS.map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </label>

        <span className="text-border">·</span>

        <span>
          {knownTotal != null ? (
            <>
              <span className="font-medium text-foreground">{knownTotal}</span> total
              {knownTotalPages > 1 && <> · page {page} of {knownTotalPages}</>}
            </>
          ) : (
            <>
              Showing <span className="font-medium text-foreground">{productsOnPage}</span> on page {page}
              {hasMore ? " · more on next page" : ""}
            </>
          )}
        </span>
      </div>

      {numberedPagination && (
        <Pagination
          currentPage={page}
          totalPages={knownTotalPages}
          onPageChange={onPageChange}
        />
      )}

      {showPrevNext && (
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            <ChevronLeft />
            Previous
          </Button>
          <Button
            variant="outline"
            size="sm"
            disabled={!hasMore}
            onClick={() => onPageChange(page + 1)}
          >
            Next
            <ChevronRight />
          </Button>
        </div>
      )}
    </div>
  );
};

export default PendingProductsFooter;
